// Stable identity for deactivatable fields/tabs in the 4 reviews.
//
// A field key is "review:<n>/screen:<id>/field:<backendKey>" and a tab key is
// "review:<n>/screen:<id>". Both are computed from context already present at
// the render site (review number per container, the active screen/tab id, and
// the field's existing backend/save key) — no new per-field ids are stored.

export type ReviewNumber = 1 | 2 | 3 | 4;

export const buildFieldKey = (review: ReviewNumber, screen: string, field: string): string =>
  `review:${review}/screen:${screen}/field:${field}`;

export const buildTabKey = (review: ReviewNumber, screen: string): string =>
  `review:${review}/screen:${screen}`;

export interface ParsedKey {
  review: ReviewNumber | null;
  screen: string;
  field: string | null;
  isTab: boolean;
}

// Parses a field or tab key back into its parts (used by the Reports
// "Deactivated" tab to display the originating review/page for each entry).
export const parseKey = (key: string): ParsedKey => {
  const reviewMatch = key.match(/review:(\d+)/);
  const screenMatch = key.match(/screen:([^/]+)/);
  const fieldMatch = key.match(/field:(.+)$/);
  const review = reviewMatch ? (Number(reviewMatch[1]) as ReviewNumber) : null;
  return {
    review: review && review >= 1 && review <= 4 ? review : null,
    screen: screenMatch ? screenMatch[1] : '',
    field: fieldMatch ? fieldMatch[1] : null,
    isTab: !fieldMatch,
  };
};
